import template from './CopilotModalView.html';
import controller from './CopilotModalController';
export default (params) => {
    return {
        template,
        controller,
        controllerAs: '$ctrl',
        ...params,
        inputs: {
            ...params.inputs,
            command: params.command,
            confirm: params.confirm,
            clickOnlearnMoreAboutCopilot: params.clickOnlearnMoreAboutCopilot,
        },
    };
};
